<template>
  <div class="loginInput">
    <!-- <input class="phoneQuery" v-focus id="phoneQuery" type="number" ref="email" v-model="params.value1"  placeholder="请输入手机号查询" pattern="[0-9]*" @input="onInput" /> -->
    <van-field
      class="phoneQuery"
      id="phoneQuery"
      v-model="params.value1"
      placeholder="请输入手机号查询"
      clearable
      autofocus="true"
      @input.native="onInput"
    />
    <div class="verificationCode">
      <van-button
        :disabled="params.rules"
        round
        block
        type="info"
        native-type="submit"
        @click.native="onFailed"
      >获取验证码</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loginInput',
  props: ['checked'],
  data() {
    return {
      params: {
        value1: '',
        pattern: /^1[3456789]\d{9}$/,
        rules: true
      },
      show: false,
      statusBtn: true
    }
  },
  watch: {
    checked(newName, oldName) {
      if (newName && this.params.value1.length == 11) {
        this.statusBtn = newName
        this.params.rules = false
      } else {
        this.statusBtn = newName
        this.params.rules = true
      }
    }
  },
  methods: {
    onInput() {
      console.log(this.statusBtn)
      if (this.params.value1.length == 11 && this.statusBtn) {
        this.params.rules = false
      } else {
        this.params.rules = true
      }
    },
    onFocus() {
      this.show = true
    },
    onFailed() {
      if (!this.params.pattern.test(this.params.value1)) {
        alert('请输入正确的手机号码')
      } else {
        let params = this.params
        this.$emit('getsendSms', params)
      }
    },
    onForwarding() {
      this.$router.push({ path: '/reportInfo/forwarding' })
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped>
.loginInput {
  width: 90%;
  margin: 0 auto;
}
</style>

